import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom'
import firebase from 'firebase/app';
import 'firebase/auth';
import firebaseConfig from './configs/firebaseConfig';
import algoliasearch from "algoliasearch";
import algoliaConfig from './configs/algoliaConfig';
import WebFont from 'webfontloader';


// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const Auth = firebase.auth()
export const fb = firebase;
export const db = firebase.firestore();
//export const fbFunctions = require('firebase-functions');

// Initialize Algolia Search 
export const algolia_client = algoliasearch(algoliaConfig.app_id, algoliaConfig.api_key); 
export const index = algolia_client.initIndex(algoliaConfig.index_name);

// // the document path is a wildcard pattern accoridng to firestore documentation 
// fbFunctions.firestore.document("submittedSurvey/{surveyID}")

// .onCreate((snap, context) => { 
//     const note = snap.data();

//     // Add an 'objectID' field which Algolia requires
//     note.objectID = context.params.noteId;
  
//     // Write to the algolia index
//     const index = algolia_client.initIndex(algoliaConfig.index_name);
//     return index.saveObject(note);
// })

//export const onSurveyCreated = fb.functions

// load font to local machine 
WebFont.load({
  google: {
    "families": ['Open Sans', 'Roboto']
  }
});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
